<div class="image-preview">
  {{#if croppers}}
  <nav role='tablist' class="cropper-tabs">
    {{#each croppers }}
      <input type="radio" {{#if @first }}checked{{/if}} data-device-name="{{ @key }}" value="{{ @key }}-cropper" id="{{ @key }}-cropper" name="cropper" data-behaviour="tabstate" aria-controls="{{ @key }}-cropper-content">
      <label for="{{ @key }}-cropper" role="tab">
        <svg class="icon icon-responsive-{{ @key }}"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="{{ iconSpriteUrl }}#icon-responsive-{{ @key }}"></use></svg>
        <svg id="active-{{@key}}-crop-icon" class="icon icon-crop"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="{{ iconSpriteUrl }}#icon-crop-alt"></use></svg>
      </label>
    {{/each }}
  </nav>
    <div class="croppers">
      {{#each croppers }}
        {{> _image-dialog-edit-cropper cropperName=@key cropperItems=(lookup ../cropperItems @key) variant=(lookup ../variants @key) imageUrl=../url }}
      {{/each}}
    </div>
  {{else}}
    <img class="preview-img" src="{{url}}" />
  {{/if}}
</div>

<div class="image-sidebar definition-list">
  <div data-review-breadcrumb="File Name" class="field"><dt class="field-label"><label for="file_name">File Name</label></dt>
<dd class="field-content"><input value="{{name}}" readonly="readonly" class="field-input text-field file-name" type="text" name="file_name" id="file_name" /></dd>
<dd class="field-comment"></dd></div><div data-review-breadcrumb="Title" class="field"><dt class="field-label"><label for="title">Title</label></dt>
<dd class="field-content"><input value="{{title}}" placeholder="{{placeholders.title}}" class="field-input text-field title" type="text" name="title" id="title" /></dd>
<dd class="field-comment"></dd></div><div data-review-breadcrumb="Alternate Text" class="field"><dt class="field-label"><label for="alt">Alternate Text</label></dt>
<dd class="field-content"><textarea placeholder="{{placeholders.alt}}" data-recommended-min="30" data-recommended-max="125" data-recommended-message="false" class="field-input text-area alt" name="alt" id="alt">
{{alt}}</textarea></dd>
<dd class="field-comment"></dd></div>
</div>
